import { Link } from "react-router-dom";
import { SocialLinks, Logo } from "@/components/common";
import { footerNavigation } from "@/data/navigation";
import { Apple, Play } from "lucide-react";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#083344] text-card font-bold">
      {/* Main Footer Content */}
      <div className="container py-12">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8">
          {/* Navigation Sections */}
          {footerNavigation.map((section) => (
            <div key={section.title}>
              <h4 className="font-semibold mb-4 text-card text-sm uppercase tracking-wider">
                {section.title}
              </h4>
              <ul className="space-y-3">
                {section.links.map((link) => (
                  <li key={link.label}>
                    {link.href.startsWith("http") ? (
                      <a
                        href={link.href}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-card/70 hover:text-card text-sm transition-colors flex items-center gap-1"
                      >
                        {link.label}
                      </a>
                    ) : (
                      <Link
                        to={link.href}
                        className="text-card/70 hover:text-card text-sm transition-colors"
                      >
                        {link.label}
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}

          {/* Download Apps Section */}
          <div>
            <h4 className="font-semibold mb-4 text-card text-sm uppercase tracking-wider">
              Get the App
            </h4>
            <div className="space-y-3">
              <a
                href="https://apps.apple.com/in/app/sparkjobs/id6670174876"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 bg-card/10 hover:bg-card/20 rounded-lg px-4 py-2 transition-colors"
              >
                <Apple className="h-6 w-6 text-card" />
                <div className="text-left">
                  <p className="text-[10px] text-card/70">Download on the</p>
                  <p className="text-sm font-semibold text-card">App Store</p>
                </div>
              </a>
              <a
                href="https://play.google.com/store/apps/details?id=in.sparkjobs.app&hl=en_IN"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 bg-card/1 hover:bg-card/20 rounded-lg px-4 py-2 transition-colors"
              >
                <div className="h-6 w-6 flex items-center justify-center">
                  <Play className="h-5 w-5 fill-current text-card" />
                </div>
                <div className="text-left">
                  <p className="text-[10px] text-card/70">Get it on</p>
                  <p className="text-sm font-semibold text-card">Google Play</p>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-card/20">
        <div className="container py-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            {/* Logo */}
            <Logo size="lg" variant="light" />

            {/* Legal Links */}
            <div className="flex flex-wrap items-center justify-center gap-4 text-sm text-card/70">
              <Link to="/terms" className="hover:text-card transition-colors">
                Terms of Use
              </Link>
              <span className="hidden md:inline">|</span>
              <Link to="/privacy" className="hover:text-card transition-colors">
                Privacy Policy
              </Link>
              <span className="hidden md:inline">|</span>
              <Link to="/cookies" className="hover:text-card transition-colors">
                Cookie Policy
              </Link>
              <span className="hidden md:inline">|</span>
              <Link to="/disclaimer" className="hover:text-card transition-colors">
                Disclaimer
              </Link>
              <span className="hidden md:inline">|</span>
              <Link to="/accessibility" className="hover:text-card transition-colors">
                Accessibility
              </Link>
            </div>

            {/* Social & Copyright */}
            <div className="flex items-center gap-6">
              <SocialLinks />
              <p className="text-card/70 text-sm">
                © {currentYear} SparkJobs
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
